export default __webpack_public_path__ + "static/media/invoice.38d871e8.svg";